// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  USER_SHOW_ADD_MODAL,
} from './constants';

export function showAddModal(visible) {
  return {
    type: USER_SHOW_ADD_MODAL,
    data:{visible}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_SHOW_ADD_MODAL:
      return {
        ...state,
        visbileAddModal: action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/showAddModal.js